module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('i', [_vm._v("To my father, Willie Howard Mays, Sr., who taught me about life, and to the people of Fairfield, Alabama, who helped raise me.")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDAU"
  }, [_vm._v("—Willie Mays")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('i', [_vm._v("To my daughter, Tereza, my wife, Zdena, and the memory of my mother, Ann. Three generations of inspirations.")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDAU"
  }, [_vm._v("—John Shea")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0